import { exception } from './analytics';
import { isFailedFetchError } from './networkError';

export const setupErrorHandlers = () => {
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    const fetchFailure = isFailedFetchError(error);
    const errorMessage = fetchFailure
      ? 'Network request failed'
      : (error?.message || error?.toString() || 'Unhandled promise rejection');

    if (fetchFailure) {
      // Keep network noise out of the browser's unhandled rejection logs.
      event.preventDefault();
    }
    
    exception(errorMessage, false);
    
    if (fetchFailure) {
      console.warn('Unhandled network request failure captured globally.');
    } else {
      console.error('Unhandled promise rejection:', error);
    }
  });

  // Handle general JavaScript errors
  window.addEventListener('error', (event) => {
    const { message, filename, lineno, colno, error } = event;
    const errorMessage = `${message} at ${filename}:${lineno}:${colno}`;
    
    exception(errorMessage, error?.name === 'TypeError');
    
    console.error('Global error:', error);
  });
};

export const trackError = (error: Error | string, context?: string) => {
  const errorMessage = error instanceof Error 
    ? `${context ? `[${context}] ` : ''}${error.message}` 
    : `${context ? `[${context}] ` : ''}${error}`;
  
  exception(errorMessage, false);
  
  console.error(context ? `Error in ${context}:` : 'Error:', error);
};